import React from "react";

const SvgAlignMergeIcon = (props) => {
  const { className, style, width, height } = props;
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width={width || "1em"}
      height={width || "1em"}
      viewBox="0 0 100 80"
      style={style}
      fill="currentColor"
    >
      <defs />
      <defs>
        <clipPath id="a">
          <path d="M0 0h100v80H0z" />
        </clipPath>
      </defs>
      <g clip-path="url(#a)">
        <g data-name="Group 19842">
          <g data-name="Group 19841">
            <path
              d="M97 0H3a2.963 2.963 0 100 5.926h94A2.963 2.963 0 1097 0z"
              data-name="Path 38521"
            />
          </g>
        </g>
        <g data-name="Group 19844">
          <g data-name="Group 19843">
            <path
              d="M97 24.593H3a2.963 2.963 0 100 5.926h94a2.963 2.963 0 100-5.926z"
              data-name="Path 38522"
            />
          </g>
        </g>
        <g data-name="Group 19846">
          <g data-name="Group 19845">
            <path
              d="M97 49.482H3a2.963 2.963 0 100 5.926h94a2.963 2.963 0 100-5.926z"
              data-name="Path 38523"
            />
          </g>
        </g>
        <g data-name="Group 19848">
          <g data-name="Group 19847">
            <path
              d="M97 74.074H3A2.963 2.963 0 103 80h94a2.963 2.963 0 100-5.926z"
              data-name="Path 38524"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default SvgAlignMergeIcon;
